import $ from 'jquery'




//显示选中状态
function showPoint (obj) {
  $("#divMain div").removeClass("change");
  $("#divMain div").addClass("small");
  $("#"+obj).addClass("change");
  $("#"+obj).removeClass("small");

  var changes =  document.getElementsByClassName("change");
  var osmall = changes[0];

  var cuti = new Array();
  cuti[0] =osmall.style.fontWeight;
  cuti[1] = osmall.style.fontStyle;
  cuti[2] = osmall.style.textDecoration;
  //  osmall.style.fontWeight+','+osmall.style.fontStyle+','+osmall.style.textDecoration;

  fuYun(osmall.style.fontFamily, osmall.style.fontSize.replace("pt",""), osmall.style.textAlign, cuti);

  posEdit(osmall.offsetLeft, osmall.offsetTop, osmall.offsetWidth, osmall.offsetHeight);
}

//移动标签事件
function smallDown(e, child) {
  var obig = document.getElementById("divMain");
  //var osmall = document.getElementById("small");
  var osmall = document.getElementById(child);

  var e = e || window.event;
  /*用于保存小的div拖拽前的坐标*/
  // 定义4个变量
  var disX =  e.clientX - osmall.offsetLeft;//鼠标按下时光标的X值
  var disY = e.clientY - osmall.offsetTop;//鼠标按下时光标的Y值
  var disW = 0; //拖拽前div的宽
  var disH = 0; // 拖拽前div的高
  /*鼠标的移动事件*/
  document.onmousemove = function(e) {
    var e = e || window.event;
    //拖拽时为了对宽和高 限制一下范围，定义两个变量
    var left = e.clientX - disX;
    var top = e.clientY -  disY;

    /*对于大的DIV四个边界的判断*/
    if (left <= 0) {
      left = 0;
    }
    if (top<= 0) {
      top = 0;
    }
    if (left + osmall.offsetWidth >= obig.offsetWidth) {
      left = obig.offsetWidth - osmall.offsetWidth;
    }
    if (top + osmall.offsetHeight>= obig.offsetHeight) {
      top =  obig.offsetHeight - osmall.offsetHeight;
    }
    osmall.style.left = left + "px";
    osmall.style.top =top + "px";
    posEdit(left, top, osmall.offsetWidth, osmall.offsetHeight)
  };
  /*鼠标的抬起事件,终止拖动*/
  document.onmouseup = function() {
    document.onmousemove = null;
    document.onmouseup = null;
  };
}


//改变大小事件
function resize(e, child) {
  var dMain = document.getElementById("divMain");
  var changes =  document.getElementsByClassName("change");
  var obig = changes[0];

  var osmall = document.getElementById(child);

  var e = e || window.event;
  /*用于保存小的div拖拽前的坐标*/
  // 定义4个变量
  var disX = e.clientX; // 获取鼠标按下时光标x的值
  var disY = e.clientY; // 获取鼠标按下时光标Y的值
  var disW = obig.offsetWidth; // 获取拖拽前div的宽
  var disH = obig.offsetHeight; // 获取拖拽前div的高

  /*鼠标的移动事件*/
  document.onmousemove = function(e) {
    var e = e || window.event;
    //拖拽时为了对宽和高 限制一下范围，定义两个变量
    var W = e.clientX - disX + disW;
    var H = e.clientY - disY + disH;
    console.log(child);
    if ( (child == "tc") || (child == "bc") )
      W = obig.offsetWidth;
    if ( (child == "cl") || (child == "cr") )
      H = obig.offsetHeight;
    /*对于大的DIV四个边界的判断*/

    if(W + obig.offsetLeft> dMain.offsetWidth)
      W = dMain.offsetWidth - obig.offsetLeft;
    if(H + obig.offsetTop> dMain.offsetHeight)
      H = dMain.offsetHeight - obig.offsetTop;


    obig.style.width = W + "px";
    obig.style.height =H + "px";
    var left = parseInt(obig.style.left.replace('px', ''));
    var top =  parseInt(obig.style.top.replace('px', ''));

    posEdit(left, top, obig.offsetWidth, obig.offsetHeight)

  };
  /*鼠标的抬起事件,终止拖动*/
  document.onmouseup = function() {
    document.onmousemove = null;
    document.onmouseup = null;
  };
}

//显示选中状态的小方块
function posEdit(left, top, width, height) {
  //顶部小点
  document.getElementById("tl").style.left =  left- 2 + "px";
  document.getElementById("tl").style.top = top- 2 + "px";

  document.getElementById("tc").style.left =  left + width / 2 + "px";
  document.getElementById("tc").style.top = top - 2 + "px";

  document.getElementById("tr").style.left =  left + width - 2 + "px";
  document.getElementById("tr").style.top = top -2+ "px";

  //中间小点
  document.getElementById("cl").style.left =  left - 2 + "px";
  document.getElementById("cl").style.top = top + height / 2 + "px";

  document.getElementById("cr").style.left =  left + width - 2  + "px";
  document.getElementById("cr").style.top = top + height / 2  + "px";

  //底部小点
  document.getElementById("bl").style.left =  left -2 + "px";
  document.getElementById("bl").style.top = top + height - 2 + "px";

  document.getElementById("bc").style.left =  left + width / 2 + "px";
  document.getElementById("bc").style.top = top + height - 2+ "px";

  document.getElementById("br").style.left =  left + width - 2 + "px";
  document.getElementById("br").style.top = top + height - 2 + "px";
}

export default {
  showPoint: function (obj) {
    return showPoint(obj)
  },

  smallDown: function(e, child) {
    return smallDown(e, child)
  },

  resize: function (e, child) {
    return resize(e, child)
  },

  addItem: function (index, row) {
    return addItem(index, row)
  },

  posEdit: function (left, top, width, height) {
    return posEdit(left, top, width, height);
  }

}



// WEBPACK FOOTER //
// ./src/api/design.js